import React from 'react';
import Button from 'screens/components/basic/Button';
import NumberInput from 'screens/components/basic/NumberInput';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';

const componentName = "ShoppingTrend";

const Header = (props) => (
    <div className="searchBarContainer">
        <div className="row row_margin_none">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 m-0">
                <NumberInput
                    name={componentName + LOOKUP.report.annualSales.year.name}
                    fullWidth={true}
                    hintText={LOOKUP.report.annualSales.year.label}
                    label={LOOKUP.report.annualSales.year.label}
                    floatingLabelText={LOOKUP.report.annualSales.year.label}
                    maxLength={4}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 m-0">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    fullWidth={true}
                    label={LOOKUP.report.common.branch}
                    defaultValue={props.loggedBranch.toString()}
                    floatingLabelText={LOOKUP.report.common.branch}
                    hintText={LOOKUP.report.common.branch}
                    options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
            </div>
        </div>
    </div>
);

export default Header;


